export default __webpack_public_path__ + "static/media/sony-wi-c200-on-table.0316ca43.png";